import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { IState, ISuccessAction, IFailureAction } from 'interfaces/create-duck';

const { Types, Creators } = createActions(
  {
    request: ['postData', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['error'],
    reset: [],
  },
  { prefix: 'IMPORT_CLIENTS_' }
);

export interface ImportClientsState extends IState {}

const INITIAL_STATE: ImportClientsState = {
  loading: false,
  error: null,
};

const request = (state: ImportClientsState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ImportClientsState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: ImportClientsState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const importClients = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ImportClientsTypes = Types;
export const ImportClientsActions = Creators;

